import guest from '@/routes/middlewares/guest'
import forgotPassword from '@/routes/middlewares/forgot-password'

const Login = () =>
    import ( /* webpackChunkName: "auth" */ '@/components/authentication/Login.vue');

const ResetPassword = () =>
    import ( /* webpackChunkName: "auth" */ '@/components/authentication/ResetPassword.vue');

const ForgotPassword = () =>
    import ( /* webpackChunkName: "auth" */ '@/components/authentication/ForgotPassword.vue');

const Checkout = () =>
    import ( /* webpackChunkName: "checkout" */ '@/pages/checkout/Checkout.vue');

// const Register = () =>
//     import ( /* webpackChunkName: "auth" */ '@/components/authentication/Register.vue');

const routes = [

    {
        path: '/forgot-password',
        component: ForgotPassword,
        meta: {
            layout: 'no-nav',
            middleware: [
                guest
            ]
        }
    },

    {
        path: '/reset-password',
        component: ResetPassword,
        meta: {
            layout: 'no-nav',
            middleware: [
                guest,
                forgotPassword
            ]
        }
    },

    {
        path: '/login',
        component: Login,
        meta: {
            title:'Login',
            layout: 'no-nav',
            middleware: [
                guest
            ]
        }

    },
    // {
    //     path: '/register',
    //     component: Register,
    //     meta: {
    //         layout: 'no-nav',
    //         middleware: [
    //             guest
    //         ]
    //     }
    // },


    {
        path: '/checkout/:plan/:period/:currency',
        component: Checkout,
        props: true,
        meta: {
            title: 'Checkout',
            layout: 'no-nav',

        }

    },



]

export default routes

// export default routes.map(route => {
//     return { ...route, meta: { forVisitor: true, layout: 'no-nav'  } }
//   })